(() => {
  const bindMenus = (root = document) => {
    root.querySelectorAll('.kp-menu').forEach((menu) => {
      if (menu.dataset.kpAccordionReady) return;
      menu.dataset.kpAccordionReady = 'true';
      menu.querySelectorAll('.kp-menu__details').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          menu.querySelectorAll('.kp-menu__details[open]').forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });
    });
  };

  bindMenus();
  document.addEventListener('shopify:section:load', (event) => bindMenus(event.target));
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.kp-menu--desktop .kp-menu__details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.kp-menu__details[open]').forEach((details) => { details.open = false; });
    }
  });
})();
